/**
 * RapidForceSelector
 * Dynamic client-side holster selector for Rapid Force Level II and III (Matches Cloak design exactly)
 */
window.RapidForceSelector = function(config) {
  'use strict';

  const prefix = config.prefix || 'rf-lvl2';
  const sectionId = config.sectionId || '';
  const dataUrl = config.dataUrl;
  const containerId = config.containerId || 'rf-selector-container';

  const pickerId = prefix + '-picker';
  const statusId = prefix + '-status';
  const handle = config.productHandle || window.location.pathname.split('/').filter(Boolean).pop().toLowerCase();
  const mfrWrapId = prefix + '-ss-mfr';
  const gunWrapId = prefix + '-ss-gun';
  const handId = prefix + '-hand';
  const axonId = prefix + '-axon';
  const axonRowId = prefix + '-axon-row';
  const lightId = prefix + '-light';
  const lightRowId = prefix + '-light-row';
  const colorId = prefix + '-color';
  const colorRowId = prefix + '-color-row';

  let allVariants = [];
  let selectedMfr = '';
  let selectedGun = '';
  let selectedHand = '';
  let selectedAxon = '';
  let selectedLight = '';
  let selectedColor = '';
  let currentHolsterPrice = null;
  let currentCompareAtPrice = null;

  const productCache = {};
  let addBtnLabel = null;
  let stateVersion = 0;

  // Set "out_of_stock": true on a variant in the holster data JSON to mark it sold out
  function isOutOfStock(entry) {
    return !!(entry && entry.out_of_stock === true);
  }

  // Lead time comes from the holster data JSON ("lead_time", edited in the
  // AGH Fitments app). Rows without one fall back to whatever Liquid
  // rendered from the product/variant metafields on page load.
  let defaultLeadTime = null;
  function updateLeadTime(entry) {
    const el = document.getElementById('lead-time');
    if (!el) return;
    if (defaultLeadTime === null) defaultLeadTime = el.getAttribute('data-lead-time') || '';
    const days = entry && entry.lead_time != null && entry.lead_time > 0 ? String(entry.lead_time) : defaultLeadTime;
    updateShipBadges(days);
    if (!days) return;

    el.setAttribute('data-lead-time', days);
    const valueEl = document.getElementById('lead-time-value');
    if (valueEl) valueEl.textContent = days === '1' ? '1 business day.' : days + ' business days.';
    // Read by rapid-force-checkout-buttons.liquid for the cart's Lead Time property.
    document.querySelectorAll('input[name="properties[Lead Time]"]').forEach(function(input) {
      input.value = days;
    });
  }

  // Same rules as main-product: 1-3 days = Ready to Ship, 4-7 days = Quick Ship, otherwise no badge
  function updateShipBadges(days) {
    const n = parseInt(days, 10);
    document.querySelectorAll('.ready-to-ship-badge').forEach(b => b.classList.toggle('rf-show', n >= 1 && n <= 3));
    document.querySelectorAll('.quick-ship-badge').forEach(b => b.classList.toggle('rf-show', n >= 4 && n <= 7));
  }

  function setAddBtnLabel(addBtn, text) {
    const span = addBtn && addBtn.querySelector('span');
    if (!span) return;
    if (addBtnLabel === null) addBtnLabel = span.textContent;
    span.textContent = text || addBtnLabel;
  }

  function boot() {
    console.log('[RapidForceSelector] Booting for prefix:', prefix, 'dataUrl:', dataUrl);
    const productDataEl = document.getElementById(prefix + '-product-data');
    
    let url = dataUrl;
    if (url && url.indexOf('//') === 0) {
      url = 'https:' + url;
    }
    console.log('[RapidForceSelector] Resolved fetch URL:', url);

    fetch(url)
      .then(r => {
        if (!r.ok) throw new Error('CDN fetch failed: HTTP ' + r.status);
        return r.json();
      })
      .catch(err => {
        console.warn('[RapidForceSelector] CDN fetch failed, trying local fallback...', err);
        let localUrl = '/assets/level-ii.json';
        const isLvl3 = (dataUrl && dataUrl.includes('level-iii')) || prefix === 'rf-lvl3';
        const isShell = dataUrl && dataUrl.includes('shell');
        if (isLvl3) {
          localUrl = isShell ? '/assets/level-iii-shell.json' : '/assets/level-iii.json';
        } else {
          localUrl = isShell ? '/assets/level-ii-shell.json' : '/assets/level-ii.json';
        }
        console.log('[RapidForceSelector] Attempting local fallback URL:', localUrl);
        return fetch(localUrl).then(r => {
          if (!r.ok) throw new Error('Local fallback fetch failed: HTTP ' + r.status);
          return r.json();
        });
      })
      .then(data => {
        allVariants = data.variants || data;
        console.log('[RapidForceSelector] Loaded variants successfully. Count:', allVariants ? allVariants.length : 0);
        if (!allVariants || !allVariants.length) {
          showError('No holster data found.');
          return;
        }
        buildUI();
        updateLeadTime(null);
        if (!prefillFromUrl()) {
          prefillFromCurrentProduct();
        }
        
        // Parse default holster price on load
        const priceContainer = document.querySelector('#price-' + sectionId + ' .price');
        if (priceContainer) {
          const isSale = priceContainer.classList.contains('price--on-sale');
          if (isSale) {
            const compareEl = priceContainer.querySelector('.price__sale .price-item--regular');
            if (compareEl) {
              const match = compareEl.textContent.match(/\d+\.\d+/);
              if (match) currentCompareAtPrice = parseFloat(match[0]);
            }
            const saleEl = priceContainer.querySelector('.price-item--sale.price-item--last');
            if (saleEl) {
              const match = saleEl.textContent.match(/\d+\.\d+/);
              if (match) currentHolsterPrice = parseFloat(match[0]);
            }
          } else {
            const regularEl = priceContainer.querySelector('.price__regular .price-item--regular');
            if (regularEl) {
              const match = regularEl.textContent.match(/\d+\.\d+/);
              if (match) currentHolsterPrice = parseFloat(match[0]);
            }
          }
        }

        // Attach event listeners to upsell selects
        const upsells = document.querySelectorAll('.rf-upsell-dropdown');
        upsells.forEach(select => {
          select.addEventListener('change', updatePrice);
        });
      })
      .catch(e => {
        console.error('[RapidForceSelector] Error loading variants:', e);
        showError('Could not load holster options. Please refresh the page.');
      });
  }

  function getMfrOptions() {
    const seen = {};
    const list = [];
    allVariants.forEach(v => {
      if (v.manufacturer && !seen[v.manufacturer]) {
        seen[v.manufacturer] = true;
        list.push({ value: v.manufacturer, label: v.manufacturer, searchText: v.manufacturer.toLowerCase() });
      }
    });
    list.sort((a, b) => a.label.localeCompare(b.label));
    return list;
  }

  function getGunOptions() {
    const seen = {};
    const list = [];
    allVariants.forEach(v => {
      if (!v.gun) return;
      if (selectedMfr && v.manufacturer !== selectedMfr) return;
      if (!seen[v.gun]) {
        seen[v.gun] = true;
        list.push({ value: v.gun, label: v.gun, searchText: v.gun.toLowerCase() });
      }
    });
    list.sort((a, b) => a.label.localeCompare(b.label));
    return list;
  }

  function getHandOptions() {
    const seen = {};
    const list = [];
    allVariants.forEach(v => {
      if (v.manufacturer === selectedMfr && v.gun === selectedGun && v.handedness && !seen[v.handedness]) {
        seen[v.handedness] = true;
        list.push(v.handedness);
      }
    });
    return list;
  }

  function isAxonLight(lightOrVariant) {
    if (lightOrVariant && typeof lightOrVariant === 'object') {
      if (lightOrVariant.axon !== undefined) {
        return lightOrVariant.axon === 'yes' || lightOrVariant.axon === true;
      }
      return /axon/i.test(lightOrVariant.light || '');
    }
    return /axon/i.test(lightOrVariant || '');
  }

  function baseLightLabel(lightOrVariant) {
    if (lightOrVariant && typeof lightOrVariant === 'object') {
      if (lightOrVariant.axon !== undefined) {
        return lightOrVariant.light;
      }
      return (lightOrVariant.light || '').replace(/\s*-\s*axon\s*$/i, '').trim();
    }
    return (lightOrVariant || '').replace(/\s*-\s*axon\s*$/i, '').trim();
  }

  // Full entry.light string implied by the currently selected base light + axon choice
  function getFullLight() {
    if (!selectedLight) return '';
    return selectedAxon === 'yes' ? (selectedLight + ' - Axon') : selectedLight;
  }

  function getAxonOptions() {
    const seen = {};
    const list = [];
    allVariants.forEach(v => {
      if (
        v.manufacturer === selectedMfr &&
        v.gun === selectedGun &&
        v.handedness === selectedHand &&
        baseLightLabel(v) === selectedLight &&
        v.color.toLowerCase() === selectedColor.toLowerCase()
      ) {
        const key = isAxonLight(v) ? 'yes' : 'no';
        if (!seen[key]) {
          seen[key] = true;
          list.push(key);
        }
      }
    });
    return list;
  }

  function getLightOptions() {
    const seen = {};
    const list = [];
    let hasNoLight = false;
    allVariants.forEach(v => {
      if (
        v.manufacturer === selectedMfr &&
        v.gun === selectedGun &&
        v.handedness === selectedHand &&
        v.light
      ) {
        const base = baseLightLabel(v);
        if (base) {
          if (base.toLowerCase() === 'no light') {
            hasNoLight = true;
          } else if (!seen[base]) {
            seen[base] = true;
            list.push(base);
          }
        }
      }
    });
    list.sort((a, b) => a.localeCompare(b));
    if (hasNoLight) {
      list.unshift('No Light');
    }
    return list;
  }

  function getColorOptions() {
    const seen = {};
    const list = [];
    allVariants.forEach(v => {
      if (
        v.manufacturer === selectedMfr &&
        v.gun === selectedGun &&
        v.handedness === selectedHand &&
        baseLightLabel(v.light) === selectedLight &&
        v.color &&
        !seen[v.color]
      ) {
        seen[v.color] = true;
        list.push(v.color);
      }
    });
    list.sort((a, b) => a.localeCompare(b));
    return list;
  }

  function caretSVG() {
    return '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"/></svg>';
  }

  function esc(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function fuzzyScore(needle, haystack) {
    if (!needle) return 1;
    needle = needle.toLowerCase().trim();
    haystack = haystack.toLowerCase();
    return haystack.indexOf(needle) !== -1 ? 1 : 0;
  }

  function createSearchableSelect(wrapperId, getOptions, onSelect, emptyPlaceholder) {
    const wrapper = document.getElementById(wrapperId);
    if (!wrapper) return;

    const trigger = wrapper.querySelector('.cloak-ss-trigger');
    const triggerLabel = wrapper.querySelector('.cloak-ss-trigger-label');
    const dropdown = wrapper.querySelector('.cloak-ss-dropdown');
    const searchInput = wrapper.querySelector('.cloak-ss-search');
    const list = wrapper.querySelector('.cloak-ss-list');

    let selectedValue = null;
    let selectedLabel = null;
    let focusedIndex = -1;

    function filterOptions(query) {
      const options = getOptions();
      if (!query) return options;
      return options
        .map(opt => ({ opt: opt, score: fuzzyScore(query, opt.searchText || opt.label) }))
        .filter(x => x.score > 0)
        .sort((a, b) => b.score - a.score || a.opt.label.localeCompare(b.opt.label))
        .map(x => x.opt);
    }

    function renderList() {
      const query = searchInput.value;
      const filtered = filterOptions(query);
      focusedIndex = -1;

      if (!filtered.length) {
        list.innerHTML = '<div class="cloak-ss-empty">No results found</div>';
        return;
      }

      list.innerHTML = filtered.map(opt => {
        const sel = opt.value === selectedValue ? ' cloak-ss-selected' : '';
        return '<div class="cloak-ss-option' + sel + '" data-value="' + esc(opt.value) + '" data-label="' + esc(opt.label) + '">' + esc(opt.label) + '</div>';
      }).join('');
    }

    function openDropdown() {
      searchInput.value = '';
      renderList();
      dropdown.classList.add('open');
      searchInput.focus();
      const selected = list.querySelector('.cloak-ss-selected');
      if (selected) selected.scrollIntoView({ block: 'nearest' });
    }

    function closeDropdown() {
      dropdown.classList.remove('open');
      focusedIndex = -1;
    }

    function selectOption(value, label) {
      selectedValue = value || null;
      selectedLabel = value ? label : null;
      triggerLabel.textContent = selectedLabel || emptyPlaceholder;
      trigger.classList.toggle('has-value', !!selectedLabel);
      closeDropdown();
      onSelect(value);
    }

    function getVisibleOptions() {
      return list.querySelectorAll('.cloak-ss-option');
    }

    function updateFocus(options) {
      options.forEach((o, i) => {
        o.classList.toggle('cloak-ss-focused', i === focusedIndex);
        if (i === focusedIndex) o.scrollIntoView({ block: 'nearest' });
      });
    }

    wrapper._ss = {
      reset: function () {
        selectedValue = null;
        selectedLabel = null;
        triggerLabel.textContent = emptyPlaceholder;
        trigger.classList.remove('has-value');
        closeDropdown();
      },
      setValue: function (value, label) {
        selectedValue = value || null;
        selectedLabel = value ? label : null;
        triggerLabel.textContent = selectedLabel || emptyPlaceholder;
        trigger.classList.toggle('has-value', !!selectedLabel);
      }
    };

    trigger.addEventListener('click', function () {
      if (dropdown.classList.contains('open')) {
        closeDropdown();
      } else {
        openDropdown();
      }
    });

    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (dropdown.classList.contains('open')) {
          closeDropdown();
        } else {
          openDropdown();
        }
      }
    });

    searchInput.addEventListener('input', function () {
      renderList();
    });

    searchInput.addEventListener('keydown', function (e) {
      const options = getVisibleOptions();
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        focusedIndex = Math.min(focusedIndex + 1, options.length - 1);
        updateFocus(options);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        focusedIndex = Math.max(focusedIndex - 1, 0);
        updateFocus(options);
      } else if (e.key === 'Enter') {
        e.preventDefault();
        if (focusedIndex >= 0 && options[focusedIndex]) {
          const opt = options[focusedIndex];
          selectOption(opt.dataset.value, opt.dataset.label);
        }
      } else if (e.key === 'Escape') {
        closeDropdown();
        trigger.focus();
      }
    });

    list.addEventListener('mousedown', function (e) {
      const opt = e.target.closest('.cloak-ss-option');
      if (opt) {
        e.preventDefault();
        selectOption(opt.dataset.value, opt.dataset.label);
      }
    });

    document.addEventListener('click', function (e) {
      if (!wrapper.contains(e.target)) {
        closeDropdown();
      }
    });
  }

  function buildUI() {
    const container = document.getElementById(containerId);
    if (!container) return;

    container.innerHTML = `
      <div class="rf-picker-rows">
        <div class="rf-dropdown-row">
          <label class="form__label">Manufacturer</label>
          <div class="cloak-ss-wrap" id="${mfrWrapId}">
            <div class="cloak-ss-trigger" role="combobox" tabindex="0">
              <span class="cloak-ss-trigger-label">Select Manufacturer</span>
            </div>
            <span class="cloak-ss-caret">${caretSVG()}</span>
            <div class="cloak-ss-dropdown">
              <div class="cloak-ss-search-wrap">
                <input type="text" class="cloak-ss-search" placeholder="Search manufacturers…" autocomplete="off" spellcheck="false">
              </div>
              <div class="cloak-ss-list"></div>
            </div>
          </div>
        </div>

        <div class="rf-dropdown-row">
          <label class="form__label">Gun Model</label>
          <div class="cloak-ss-wrap" id="${gunWrapId}">
            <div class="cloak-ss-trigger" role="combobox" tabindex="0">
              <span class="cloak-ss-trigger-label">Select Gun Model</span>
            </div>
            <span class="cloak-ss-caret">${caretSVG()}</span>
            <div class="cloak-ss-dropdown">
              <div class="cloak-ss-search-wrap">
                <input type="text" class="cloak-ss-search" placeholder="Search gun models…" autocomplete="off" spellcheck="false">
              </div>
              <div class="cloak-ss-list"></div>
            </div>
          </div>
        </div>

        <div class="rf-dropdown-row">
          <label class="form__label" for="${handId}">Draw Hand</label>
          <div class="select">
            <select id="${handId}" class="select__select">
              <option value="">Select Draw Hand</option>
            </select>
            <span class="svg-wrapper">${caretSVG()}</span>
          </div>
        </div>

        <div class="rf-dropdown-row" id="${lightRowId}" style="display:none;">
          <label class="form__label" for="${lightId}">Light</label>
          <div class="select">
            <select id="${lightId}" class="select__select">
              <option value="">Select Light</option>
            </select>
            <span class="svg-wrapper">${caretSVG()}</span>
          </div>
        </div>

        <div class="rf-dropdown-row" id="rf-optics-row" style="display:none;">
          <label class="form__label">Optic</label>
          <div style="margin-top: 0.5rem; padding: 0.5rem 0;">
            <a href="${prefix === 'rf-lvl3' ? 'https://aliengearholsters.gorgias.help/en-US/rapid-force-level-iii-optic-compatibility-8438223' : 'https://aliengearholsters.gorgias.help/en-US/rapid-force-level-ii-optic-compatibility-7756524'}" target="_blank" style="color: var(--ag-black, #191C1F); font-weight: normal; text-decoration: underline; font-size: 1.3rem; text-transform: uppercase; letter-spacing: 0.05em; display: inline-flex; align-items: center; gap: 0.5rem;">
              Rapid Force Level ${prefix === 'rf-lvl3' ? 'III' : 'II'} Optic Compatibility
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width: 1.2rem; height: 1.2rem;">
                <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                <polyline points="15 3 21 3 21 9"></polyline>
                <line x1="10" y1="14" x2="21" y2="3"></line>
              </svg>
            </a>
          </div>
        </div>

        <div class="rf-dropdown-row" id="${colorRowId}" style="display:none;">
          <label class="form__label" for="${colorId}">Color</label>
          <div class="select">
            <select id="${colorId}" class="select__select">
              <option value="">Select Color</option>
            </select>
            <span class="svg-wrapper">${caretSVG()}</span>
          </div>
        </div>

        <div class="rf-dropdown-row" id="${axonRowId}" style="display:none;">
          <div class="rf-upsell-label-row" style="margin-bottom: 0.6rem;">
            <label class="form__label" for="${axonId}" style="margin-bottom: 0;">Axon Signal <span style="font-size:1.1rem; font-weight: 400; text-transform: none; color:var(--ag-gray-500, #64748b);">(law enforcement only)</span></label>
            <span class="rf-info-wrap">
              <button type="button" class="rf-info-btn" aria-expanded="false" aria-label="View Axon Signal details" data-rf-info-toggle><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12.01" y2="17"></line></svg></button>
              <div class="rf-info-popover" data-rf-info-popover>
                <img src="https://cdn.shopify.com/s/files/1/0881/4854/1726/files/Glock_Level_3_AXON_NOW-9.jpg" alt="Axon Signal Sidearm" loading="lazy">
                <p class="rf-info-popover__title">Axon Signal Sidearm</p>
                <p style="font-size: 1.1rem; line-height: 1.3; margin: 0; color: #475569;">The Axon Signal Sidearm sensor detects when a handgun is drawn and alerts Axon body-worn cameras to record.</p>
              </div>
            </span>
          </div>
          <div class="select">
            <select id="${axonId}" class="select__select">
              <option value="">Select</option>
            </select>
            <span class="svg-wrapper">${caretSVG()}</span>
          </div>
        </div>

        <div id="${statusId}" style="display:none; font-size:1.3rem; color:#c00; margin-top:0.5rem;"></div>
      </div>
    `;

    createSearchableSelect(mfrWrapId, getMfrOptions, function(value) {
      selectedMfr = value || '';
      selectedGun = '';
      selectedHand = '';
      selectedLight = '';
      selectedColor = '';
      selectedAxon = '';

      const gunSS = document.getElementById(gunWrapId);
      if (gunSS && gunSS._ss) gunSS._ss.reset();

      refreshHandedness();
      refreshLight();
      refreshColor();
      refreshAxon();
      updateState();
    }, 'Select Manufacturer');

    createSearchableSelect(gunWrapId, getGunOptions, function(value) {
      selectedGun = value || '';
      selectedHand = '';
      selectedLight = '';
      selectedColor = '';
      selectedAxon = '';

      refreshHandedness();
      refreshLight();
      refreshColor();
      refreshAxon();
      updateState();
    }, 'Select Gun Model');

    attachEvents();
  }

  function attachEvents() {
    const handSelect = document.getElementById(handId);
    if (handSelect) {
      handSelect.addEventListener('change', function() {
        selectedHand = this.value || '';
        selectedLight = '';
        selectedColor = '';
        selectedAxon = '';
        refreshLight();
        refreshColor();
        refreshAxon();
        updateState();
      });
    }

    const lightSelect = document.getElementById(lightId);
    if (lightSelect) {
      lightSelect.addEventListener('change', function() {
        selectedLight = this.value || '';
        selectedColor = '';
        selectedAxon = '';
        refreshColor();
        refreshAxon();
        updateState();
      });
    }

    const colorSelect = document.getElementById(colorId);
    if (colorSelect) {
      colorSelect.addEventListener('change', function() {
        selectedColor = this.value || '';
        selectedAxon = '';
        refreshAxon();
        updateState();
      });
    }

    const axonSelect = document.getElementById(axonId);
    if (axonSelect) {
      axonSelect.addEventListener('change', function() {
        selectedAxon = this.value || '';
        updateState();
      });
    }

    const container = document.getElementById(containerId);
    if (container) {
      const infoToggle = container.querySelector('[data-rf-info-toggle]');
      if (infoToggle) {
        infoToggle.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          const popover = this.parentElement.querySelector('[data-rf-info-popover]');
          if (!popover) return;
          const isOpen = popover.classList.contains('open');
          document.querySelectorAll('.rf-info-popover.open').forEach(p => p.classList.remove('open'));
          document.querySelectorAll('[data-rf-info-toggle][aria-expanded="true"]').forEach(b => b.setAttribute('aria-expanded', 'false'));
          if (!isOpen) {
            popover.classList.add('open');
            this.setAttribute('aria-expanded', 'true');
          }
        });
      }
    }
  }

  function refreshHandedness() {
    const handSelect = document.getElementById(handId);
    if (!handSelect) return;

    if (!selectedGun) {
      handSelect.innerHTML = '<option value="">Select Draw Hand</option>';
      return;
    }

    const hands = getHandOptions();
    let opts = '<option value="">Select Draw Hand</option>';
    hands.forEach(h => {
      opts += `<option value="${esc(h)}">${esc(h)} Hand</option>`;
    });
    handSelect.innerHTML = opts;
  }

  function refreshLight() {
    const row = document.getElementById(lightRowId);
    const lightSelect = document.getElementById(lightId);
    const opticsRow = document.getElementById('rf-optics-row');
    if (!row || !lightSelect) return;

    if (!selectedGun || !selectedHand) {
      row.style.display = 'none';
      if (opticsRow) opticsRow.style.display = 'none';
      lightSelect.innerHTML = '<option value="">Select Light</option>';
      return;
    }

    const lights = getLightOptions();
    let opts = '<option value="">Select Light</option>';
    lights.forEach(l => {
      opts += `<option value="${esc(l)}">${esc(l)}</option>`;
    });
    lightSelect.innerHTML = opts;
    row.style.display = '';
  }

  function refreshColor() {
    const row = document.getElementById(colorRowId);
    const colorSelect = document.getElementById(colorId);
    const opticsRow = document.getElementById('rf-optics-row');
    if (!row || !colorSelect) return;

    if (!selectedGun || !selectedHand || !selectedLight) {
      row.style.display = 'none';
      if (opticsRow) opticsRow.style.display = 'none';
      colorSelect.innerHTML = '<option value="">Select Color</option>';
      return;
    }

    const colors = getColorOptions();
    let opts = '<option value="">Select Color</option>';
    colors.forEach(c => {
      opts += `<option value="${esc(c)}">${esc(c.charAt(0).toUpperCase() + c.slice(1))}</option>`;
    });
    colorSelect.innerHTML = opts;
    row.style.display = '';
    if (opticsRow) opticsRow.style.display = '';
  }

  function refreshAxon() {
    const row = document.getElementById(axonRowId);
    const axonSelect = document.getElementById(axonId);
    if (!row || !axonSelect) return;

    if (!selectedGun || !selectedHand || !selectedLight || !selectedColor) {
      row.style.display = 'none';
      axonSelect.innerHTML = '<option value="">Select</option>';
      return;
    }

    const axonOptions = getAxonOptions();
    if (!axonOptions.includes('yes')) {
      selectedAxon = 'no';
      row.style.display = 'none';
      return;
    }

    let opts = '<option value="">Select</option>';
    axonOptions.forEach(a => {
      opts += `<option value="${esc(a)}">${a === 'yes' ? 'Yes' : 'No'}</option>`;
    });
    axonSelect.innerHTML = opts;
    row.style.display = '';
  }

  function slugify(str) {
    return String(str)
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function updateUrl() {
    const params = new URLSearchParams(window.location.search);
    if (selectedMfr) params.set('manufacturer', slugify(selectedMfr));
    else params.delete('manufacturer');
    if (selectedGun) params.set('gun', slugify(selectedGun));
    else params.delete('gun');
    if (selectedHand) params.set('hand', slugify(selectedHand));
    else params.delete('hand');
    if (selectedLight) params.set('light', slugify(selectedLight));
    else params.delete('light');
    if (selectedAxon) params.set('axon', slugify(selectedAxon));
    else params.delete('axon');
    if (selectedColor) params.set('color', slugify(selectedColor));
    else params.delete('color');
    const query = params.toString();
    window.history.replaceState(null, '', window.location.pathname + (query ? '?' + query : ''));
  }

  function prefillFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const mfrParam = params.get('manufacturer');
    const gunParam = params.get('gun');
    const handParam = params.get('hand');
    const lightParam = params.get('light');
    const axonParam = params.get('axon');
    const colorParam = params.get('color');

    if (!mfrParam && !gunParam) return false;

    let matchedMfr = '';
    if (mfrParam) {
      const mfrSelectWrap = document.getElementById(mfrWrapId);
      const mfrOptions = getMfrOptions();
      const mfrFound = mfrOptions.find(o => o.value && (o.value === mfrParam || slugify(o.value) === mfrParam));
      if (mfrFound && mfrSelectWrap && mfrSelectWrap._ss) {
        mfrSelectWrap._ss.setValue(mfrFound.value, mfrFound.label);
        selectedMfr = mfrFound.value;
        matchedMfr = mfrFound.value;
      }
    }

    if (!matchedMfr) return false;
    enableRow(`${prefix}-row-gun`);

    let matchedGun = '';
    if (gunParam) {
      const gunSS = document.getElementById(gunWrapId);
      const gunOptions = getGunOptions();
      const gunFound = gunOptions.find(o => o.value && (o.value === gunParam || slugify(o.value) === gunParam));
      if (gunFound && gunSS && gunSS._ss) {
        gunSS._ss.setValue(gunFound.value, gunFound.value);
        selectedGun = gunFound.value;
        matchedGun = gunFound.value;
      }
    }

    if (!matchedGun) return true;
    enableRow(`${prefix}-row-hand`);
    refreshHandedness();

    if (handParam) {
      const handSelect = document.getElementById(handId);
      if (handSelect) {
        const handFound = Array.from(handSelect.options).find(o => o.value && (o.value === handParam || slugify(o.value) === handParam));
        if (handFound) {
          handSelect.value = handFound.value;
          selectedHand = handFound.value;
          enableRow(`${prefix}-row-light`);
          refreshLight();
        }
      }
    }

    if (!selectedHand) return true;

    if (lightParam) {
      const lightSelect = document.getElementById(lightId);
      if (lightSelect) {
        const lightFound = Array.from(lightSelect.options).find(o => o.value && (o.value === lightParam || slugify(o.value) === lightParam));
        if (lightFound) {
          lightSelect.value = lightFound.value;
          selectedLight = lightFound.value;
          enableRow(`${prefix}-row-color`);
          refreshColor();
        }
      }
    }

    if (!selectedLight) return true;

    if (colorParam) {
      const colorSelect = document.getElementById(colorId);
      if (colorSelect) {
        const colorFound = Array.from(colorSelect.options).find(o => o.value.toLowerCase() === colorParam || slugify(o.value) === colorParam);
        if (colorFound) {
          colorSelect.value = colorFound.value;
          selectedColor = colorFound.value;
          enableRow(`${prefix}-row-axon`);
          refreshAxon();
        }
      }
    }

    if (!selectedColor) return true;

    if (axonParam) {
      const axonSelect = document.getElementById(axonId);
      if (axonSelect) {
        const axonFound = Array.from(axonSelect.options).find(o => o.value && (o.value === axonParam || slugify(o.value) === axonParam));
        if (axonFound) {
          axonSelect.value = axonFound.value;
          selectedAxon = axonFound.value;
        }
      }
    }

    updateState();
    return true;
  }

  function prefillFromCurrentProduct() {
    const mfrSelectWrap = document.getElementById(mfrWrapId);
    if (!mfrSelectWrap) return;

    let currentMfr = '';
    let currentLight = '';

    const pageTitle = (document.title || '').toLowerCase();
    const bodyText = document.body.textContent.toLowerCase();

    if (handle.includes('glock') || pageTitle.includes('glock')) currentMfr = 'Glock';
    else if (handle.includes('sig-sauer') || handle.includes('sig') || pageTitle.includes('sig')) currentMfr = 'Sig Sauer';
    else if (handle.includes('smith-wesson') || handle.includes('smith') || handle.includes('s&w') || pageTitle.includes('smith')) currentMfr = 'Smith & Wesson';
    else if (handle.includes('springfield') || pageTitle.includes('springfield')) currentMfr = 'Springfield';
    else if (handle.includes('archon') || pageTitle.includes('archon')) currentMfr = 'Archon';

    if (bodyText.includes('compact light')) currentLight = 'Compact Light';
    else if (bodyText.includes('large light') || bodyText.includes('light-bearing')) {
      if (bodyText.includes('axon')) currentLight = 'Large Light - Axon';
      else currentLight = 'Large Light';
    } else if (bodyText.includes('no light') || bodyText.includes('no-light')) {
      currentLight = 'No Light';
    }

    if (currentMfr) {
      mfrSelectWrap._ss.setValue(currentMfr, currentMfr);
      selectedMfr = currentMfr;
      enableRow(`${prefix}-row-gun`);

      // Trigger selection of first gun model
      const guns = getGunOptions();
      if (guns.length > 0) {
        const gunSS = document.getElementById(gunWrapId);
        if (gunSS && gunSS._ss) {
          gunSS._ss.setValue(guns[0].value, guns[0].value);
          selectedGun = guns[0].value;
          enableRow(`${prefix}-row-hand`);
          refreshHandedness();
          
          // Auto fill draw hand to Right as default
          setTimeout(() => {
            const handSelect = document.getElementById(handId);
            if (handSelect) {
              const options = Array.from(handSelect.options);
              const hasRight = options.some(o => o.value === 'Right');
              if (hasRight) {
                handSelect.value = 'Right';
                selectedHand = 'Right';
                enableRow(`${prefix}-row-light`);
                refreshLight();

                // Auto fill Light
                setTimeout(() => {
                  const lightSelect = document.getElementById(lightId);
                  const baseLight = baseLightLabel(currentLight);
                  if (lightSelect && baseLight) {
                    const hasLight = Array.from(lightSelect.options).some(o => o.value === baseLight);
                    if (hasLight) {
                      lightSelect.value = baseLight;
                      selectedLight = baseLight;
                      enableRow(`${prefix}-row-color`);
                      refreshColor();

                      // Auto fill Color
                      setTimeout(() => {
                        const colorSelect = document.getElementById(colorId);
                        let currentColor = 'black';
                        if (bodyText.includes('tan')) currentColor = 'tan';
                        else if (bodyText.includes('basketweave') || bodyText.includes('basket-weave')) currentColor = 'basket-weave';
                        
                        if (colorSelect) {
                          const hasColor = Array.from(colorSelect.options).some(o => o.value.toLowerCase() === currentColor);
                          const colorVal = hasColor ? currentColor : (colorSelect.options[1] ? colorSelect.options[1].value : '');
                          if (colorVal) {
                            colorSelect.value = colorVal;
                            selectedColor = colorVal;
                            enableRow(`${prefix}-row-axon`);
                            refreshAxon();

                            // Auto fill Axon
                            setTimeout(() => {
                              const axonSelect = document.getElementById(axonId);
                              if (axonSelect) {
                                const axonVal = isAxonLight(currentLight) ? 'yes' : 'no';
                                axonSelect.value = axonVal;
                                selectedAxon = axonVal;
                              }
                              updateState();
                            }, 50);
                          }
                        }
                      }, 50);
                    }
                  }
                }, 50);
              }
            }
          }, 50);
        }
      }
    }
  }

  function updateState() {
    const version = ++stateVersion;
    const status = document.getElementById(statusId);
    const addBtn = document.querySelector('button[name="add"]') || document.getElementById('rf-btn-add-to-cart');
    
    if (status) status.style.display = 'none';
    if (addBtn) {
      addBtn.disabled = true;
      addBtn.setAttribute('aria-disabled', 'true');
      setAddBtnLabel(addBtn);
    }
    // Back to the product's default until a full combination is matched
    updateLeadTime(null);

    if (!selectedMfr || !selectedGun || !selectedHand || !selectedLight || !selectedColor) {
      updateUrl();
      return;
    }

    const axonOptions = getAxonOptions();
    const hasAxon = axonOptions.includes('yes');
    if (hasAxon && !selectedAxon) {
      updateUrl();
      return;
    }

    const axonVal = hasAxon ? selectedAxon : 'no';
    const fullLight = axonVal === 'yes' ? (selectedLight + ' - Axon') : selectedLight;

    const entry = allVariants.find(v =>
      v.manufacturer === selectedMfr &&
      v.gun === selectedGun &&
      v.handedness === selectedHand &&
      baseLightLabel(v) === selectedLight &&
      (isAxonLight(v) ? 'yes' : 'no') === axonVal &&
      v.color.toLowerCase() === selectedColor.toLowerCase()
    );

    if (!entry) {
      if (status) {
        status.textContent = 'This combination is not available.';
        status.style.display = 'block';
      }
      updateUrl();
      return;
    }

    updateUrl();
    updateNativeElements(entry);

    if (isOutOfStock(entry)) {
      if (status) {
        status.textContent = 'This configuration is currently out of stock.';
        status.style.display = 'block';
      }
      setAddBtnLabel(addBtn, 'Sold out');
      return;
    }

    const targetProductHandle = getProductHandle(entry) || handle;
    getVariantId(targetProductHandle, entry, (variantId) => {
      if (version !== stateVersion) return; // selection changed while the lookup was in flight
      if (variantId) {
        const cache = productCache[targetProductHandle];
        const isConsolidatedFallback = cache && cache.variants && cache.variants.length === 1;
        const matchedVariant = cache ? cache.variants.find(v => v.id === variantId) : null;
        if (prefix === 'rf-lvl2' || prefix === 'rf-lvl3') {
          currentCompareAtPrice = null;
          currentHolsterPrice = entry.price;
        } else if (matchedVariant && !isConsolidatedFallback) {
          currentCompareAtPrice = matchedVariant.compare_at_price ? matchedVariant.compare_at_price / 100.0 : null;
          currentHolsterPrice = matchedVariant.price ? matchedVariant.price / 100.0 : entry.price;
        } else {
          currentCompareAtPrice = null;
          currentHolsterPrice = entry.price;
        }
        // Delay updatePrice to ensure it executes after theme scripts finish their override
        setTimeout(() => {
          updatePrice();
        }, 150);
        const variantInput = 
          document.querySelector('input[name="id"].product-variant-id') ||
          document.querySelector(`#product-form-${sectionId} input[name="id"]`) ||
          document.querySelector('form[action*="/cart/add"] input[name="id"]');
          
        if (variantInput) {
          variantInput.value = variantId;
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
          // Wait for theme's event listener to finish, then override display price back
          setTimeout(() => {
            updatePrice();
          }, 150);
        }

        if (addBtn) {
          addBtn.disabled = false;
          addBtn.removeAttribute('aria-disabled');
        }

        const priceCents = Math.round(currentHolsterPrice * 100);
        const forms = document.querySelectorAll('form[action*="/cart/add"]');
        forms.forEach(form => {
          setLineItemProperty(form, '_display_price', priceCents.toString());
          setLineItemProperty(form, '_sku', entry.sku || '');

          setLineItemProperty(form, 'Gun Model', entry.manufacturer + ' ' + entry.gun);
          setLineItemProperty(form, 'Draw Hand', entry.handedness);
          setLineItemProperty(form, 'Light', entry.light);
          setLineItemProperty(form, 'Axon Signal', isAxonLight(entry) ? 'Yes' : 'No');
          setLineItemProperty(form, 'Color', entry.color);
        });
      } else {
        if (status) {
          status.textContent = 'Product is unavailable in the store.';
          status.style.display = 'block';
        }
      }
    });
  }

  function updateNativeElements(entry) {
    const skuContainer = document.getElementById('Sku-' + sectionId);
    if (skuContainer) {
      skuContainer.classList.remove('visibility-hidden');
      const valueEl = skuContainer.querySelector('.product__sku--value') || skuContainer;
      valueEl.textContent = entry.sku;
    }

    currentHolsterPrice = entry.price;
    currentCompareAtPrice = null;
    updatePrice();

    updateGalleryImage(entry.image);
    updateLeadTime(entry);
  }

  function updateGalleryImage(imageUrl) {
    if (!imageUrl) return;
    
    const cleanTarget = imageUrl.split('?')[0].replace(/^https?:/, '');
    const gallery = document.querySelector('media-gallery');
    if (!gallery) {
      const mainImg = document.querySelector('.product__media img') || document.querySelector('.product-media-container img');
      if (mainImg) {
        mainImg.src = imageUrl;
        if (mainImg.hasAttribute('srcset')) mainImg.srcset = imageUrl;
      }
      return;
    }
    
    const imgs = gallery.querySelectorAll('img');
    let matchedMediaId = null;
    
    for (let img of imgs) {
      const cleanSrc = img.src.split('?')[0].replace(/^https?:/, '');
      const targetFilename = cleanTarget.substring(cleanTarget.lastIndexOf('/') + 1);
      const srcFilename = cleanSrc.substring(cleanSrc.lastIndexOf('/') + 1);
      
      if (srcFilename === targetFilename && targetFilename) {
        const li = img.closest('[data-media-id]');
        if (li) {
          matchedMediaId = li.dataset.mediaId;
          break;
        }
        const thumbLi = img.closest('[data-target]');
        if (thumbLi) {
          matchedMediaId = thumbLi.dataset.target;
          break;
        }
      }
    }
    
    if (matchedMediaId && typeof gallery.setActiveMedia === 'function') {
      console.log('[RapidForceSelector] Activating gallery media ID:', matchedMediaId);
      gallery.setActiveMedia(matchedMediaId, false);
    } else {
      console.log('[RapidForceSelector] Falling back to direct src swap for:', imageUrl);
      const mainImg = gallery.querySelector('.product__media img') || gallery.querySelector('.product-media-container img');
      if (mainImg) {
        mainImg.src = imageUrl;
        if (mainImg.hasAttribute('srcset')) mainImg.srcset = imageUrl;
      }
    }
  }

  function setLineItemProperty(form, name, value) {
    let existing = form.querySelector(`input[name="properties[${name}]"]`);
    if (existing) {
      existing.value = value;
    } else {
      const hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = `properties[${name}]`;
      hidden.value = value;
      form.appendChild(hidden);
    }
  }

  const LEVEL2_HANDLES_MAP = {
    'glock|compact-light': 'rapid-force-level-ii-duty-holster-for-glock-compact-light-dealer',
    'glock|axon': 'rapid-force-level-ii-duty-holster-for-glock-large-light-axon-dealer',
    'glock|large-light': 'rapid-force-level-ii-duty-holster-for-glock-large-light-dealer',
    'glock|no-light': 'rapid-force-level-ii-duty-holster-for-glock-no-light-dealer',

    'sig sauer|compact-light': 'rapid-force-level-ii-duty-holster-for-sig-sauer-compact-light-dealer',
    'sig sauer|axon': 'rapid-force-level-ii-duty-holster-for-sig-sauer-large-light-axon-dealer',
    'sig sauer|large-light': 'rapid-force-level-ii-duty-holster-for-sig-sauer-large-light-dealer',
    'sig sauer|no-light': 'rapid-force-level-ii-duty-holster-for-sig-sauer-no-light-dealer',

    'smith & wesson|axon': 'rapid-force-level-ii-duty-holster-for-smith-wesson-large-light-axon-dealer',
    'smith & wesson|large-light': 'rapid-force-level-ii-duty-holster-for-smith-wesson-large-light-dealer',

    'springfield|compact-light': 'rapid-force-level-ii-replacement-shell-for-springfield-compact-light-shell-only',
    'springfield|no-light': 'rapid-force-level-ii-replacement-shell-springfield-no-light-shell-only'
  };

  function getProductHandle(entry) {
    // Level II and III both add the consolidated product; SKU and price come from the JSON entry
    return '';
  }

  // sku format is R2-B-.../R3-M-... for full holsters and R2-S-.../R3-S-... for replacement shells
  function isShellSku(sku) {
    return /^R[23]-S-/i.test(sku || '');
  }

  const LEVEL2_SHELL_HANDLES = {
    'sig sauer|large light': 'rapid-force-level-ii-duty-holster-for-sig-sauer-large-light-dealer',
    'glock|no light': 'rapid-force-level-ii-duty-holster-for-glock-no-light-dealer',
    'springfield|compact light': 'rapid-force-level-ii-replacement-shell-for-springfield-compact-light-shell-only'
  };

  function getLevel2ShellHandle(entry) {
    const key = entry.manufacturer.toLowerCase() + '|' + entry.light.toLowerCase();
    return LEVEL2_SHELL_HANDLES[key] || '';
  }

  const LEVEL3_HANDLES = {
    'glock|large light|false': 'rapid-force-level-3-duty-holster-glock-light-bearing',
    'glock|large light|true': 'rapid-force-level-iii-duty-holster-for-glock-large-light-dealer',
    'glock|large light - axon|false': 'rapid-force-level-3-duty-holster-glock-axon',
    'glock|large light - axon|true': 'rapid-force-level-iii-duty-holster-for-glock-large-light-axon-dealer',
    'glock|no light|false': 'rapid-force-level-3-duty-holster-glock-no-light',
    'glock|no light|true': 'rapid-force-level-iii-duty-holster-for-glock-no-light-dealer',
    'glock|compact light|false': 'rapid-force-level-iii-duty-holster-for-glock-compact-light',
    'glock|compact light|true': 'rapid-force-level-iii-duty-holster-for-glock-compact-light-dealer',
    'glock|compact light - axon|false': 'rapid-force-level-iii-duty-holster-for-glock-large-light-copy',
    'glock|compact light - axon|true': 'rapid-force-level-iii-replacement-shell-for-glock-compact-light-axon-shell-only',
    'sig sauer|large light|false': 'rapid-force-level-3-duty-holster-sig-sauer-light-bearing',
    'sig sauer|large light|true': 'rapid-force-level-iii-duty-holster-for-sig-sauer-large-light-dealer',
    'sig sauer|large light - axon|false': 'rapid-force-level-3-duty-holster-sig-sauer-axon',
    'sig sauer|large light - axon|true': 'rapid-force-level-iii-duty-holster-for-sig-sauer-large-light-axon-dealer',
    'sig sauer|no light|false': 'rapid-force-level-3-duty-holster-sig-sauer-no-light',
    'sig sauer|no light|true': 'rapid-force-level-iii-duty-holster-for-sig-sauer-no-light-dealer',
    'sig sauer|compact light|false': 'rapid-force-level-3-duty-holster-sig-sauer-compact-light',
    'sig sauer|compact light|true': 'rapid-force-level-iii-duty-holster-for-sig-sauer-compact-light-dealer',
    'smith & wesson|large light|false': 'rapid-force-level-iii-smith-wesson-light-bearing',
    'smith & wesson|large light|true': 'rapid-force-level-iii-duty-holster-for-smith-wesson-large-light-dealer',
    'smith & wesson|large light - axon|false': 'rapid-force-level-iii-duty-holster-for-smith-wesson-axon',
    'smith & wesson|large light - axon|true': 'rapid-force-level-iii-duty-holster-for-smith-wesson-large-light-axon-dealer',
    'smith & wesson|no light|false': 'rapid-force-level-iii-duty-holster-for-smith-wesson-no-light',
    'smith & wesson|no light|true': 'rapid-force-level-iii-duty-holster-for-smith-wesson-no-light-dealer',
    'archon|large light|false': 'rapid-force-level-iii-duty-holster-for-archon-large-light',
    'archon|large light|true': 'rapid-force-level-iii-duty-holster-for-archon-large-light-shell-only'
  };

  function getNormalizedLightName(entry) {
    // Full and shell SKUs share the same light/axon codes, so derive the light type from the SKU
    const parts = (entry.sku || '').split('-');
    if (parts.length >= 7) {
      const lightCode = parts[5];
      const axonCode = parts[6];
      let type = '';
      if (lightCode === 'LL') type = 'large light';
      else if (lightCode === 'CL' || lightCode === 'SL') type = 'compact light';
      else if (lightCode === 'L0') type = 'no light';
      
      if (axonCode === 'AX' && type) {
        type += ' - axon';
      }
      if (type) return type;
    }
    let lower = entry.light.toLowerCase();
    if (lower.includes('no light')) return 'no light';
    if (lower.includes('axon')) {
      if (lower.includes('compact')) return 'compact light - axon';
      return 'large light - axon';
    }
    if (lower.includes('compact')) return 'compact light';
    return 'large light';
  }

  function getLevel3ProductHandle(entry) {
    const key = entry.manufacturer.toLowerCase() + '|' + getNormalizedLightName(entry) + '|' + isShellSku(entry.sku);
    return LEVEL3_HANDLES[key] || '';
  }

  function getVariantId(handle, entry, callback) {
    const sku = entry.sku;
    
    function findVariant(product) {
      console.log("[RapidForceSelector Debug] Matching variant for SKU:", sku, "handle:", handle);
      // 1. Try to find by SKU
      let match = product.variants.find(v => v.sku === sku);
      if (match) {
        console.log("[RapidForceSelector Debug] Matched by SKU directly:", match.id);
        return match.id;
      }
      
      // 2. Fallback to matching by options (gun, handedness, color)
      match = product.variants.find(v => {
        let opt1Match = false;
        if (v.option1 && entry.gun) {
          let op1 = v.option1.toLowerCase().replace(/[^a-z0-9]+/g, '');
          let eg = entry.gun.toLowerCase().replace(/[^a-z0-9]+/g, '');
          opt1Match = (op1 === eg || op1.includes(eg) || eg.includes(op1));
        } else {
          opt1Match = true;
        }
        
        let opt2Match = false;
        if (v.option2 && entry.handedness) {
          opt2Match = v.option2.toLowerCase() === entry.handedness.toLowerCase();
        } else {
          opt2Match = true;
        }
        
        let opt3Match = false;
        if (v.option3 && entry.color) {
          opt3Match = v.option3.toLowerCase() === entry.color.toLowerCase();
        } else {
          opt3Match = true;
        }
        
        return opt1Match && opt2Match && opt3Match;
      });
      if (match) {
        console.log("[RapidForceSelector Debug] Match by options:", match.id);
        return match.id;
      }
      
      // 3. Fallback to single/default variant (for consolidated wrapper products)
      if (product.variants && product.variants.length === 1) {
        console.log("[RapidForceSelector Debug] Fallback to single variant:", product.variants[0].id);
        return product.variants[0].id;
      }

      console.log("[RapidForceSelector Debug] Match by options: none found");
      return null;
    }

    if (productCache[handle]) {
      callback(findVariant(productCache[handle]));
      return;
    }

    fetch(`/products/${handle}.js`)
      .then(res => {
        if (!res.ok) throw new Error('First fetch failed');
        return res.json();
      })
      .then(product => {
        productCache[handle] = product;
        callback(findVariant(product));
      })
      .catch(err => {
        let fallbacks = [];
        if (handle.includes('duty-holster')) {
          fallbacks.push(handle.replace('duty-holster', 'holster'));
        }
        if (handle.includes('level-2')) {
          fallbacks.push(handle.replace('level-2', 'level-ii'));
        }
        if (handle.includes('level-2-duty-holster')) {
          fallbacks.push(handle.replace('level-2-duty-holster', 'level-ii-holster'));
        }

        const tryNext = (index) => {
          if (index >= fallbacks.length) {
            console.error("Error fetching product variant ID after fallbacks:", err);
            callback(null);
            return;
          }
          const fallbackHandle = fallbacks[index];
          console.log(`[RapidForceSelector] Trying fallback handle: ${fallbackHandle}`);
          fetch(`/products/${fallbackHandle}.js`)
            .then(res => {
              if (!res.ok) throw new Error('Fallback failed');
              return res.json();
            })
            .then(product => {
              productCache[fallbackHandle] = product;
              callback(findVariant(product));
            })
            .catch(() => tryNext(index + 1));
        };

        tryNext(0);
      });
  }

  function showError(msg) {
    const container = document.getElementById(containerId);
    if (container) {
      container.innerHTML = `<div class="rf-error" style="color:#c00; font-size:1.3rem;">${msg}</div>`;
    }
  }

  function updatePrice() {
    let basePrice = currentHolsterPrice;
    if (basePrice === null) return;

    let totalPrice = basePrice;
    let totalComparePrice = currentCompareAtPrice;

    // Add any selected upsell dropdown prices
    const upsells = document.querySelectorAll('.rf-upsell-dropdown');
    upsells.forEach(select => {
      if (select.value) {
        const selectedOption = select.options[select.selectedIndex];
        const price = selectedOption ? parseFloat(selectedOption.getAttribute('data-price') || '0') / 100.0 : 0;
        totalPrice += price;
        if (totalComparePrice) {
          totalComparePrice += price;
        }
      }
    });

    const priceContainer = document.querySelector('#price-' + sectionId + ' .price');
    if (priceContainer) {
      if (totalComparePrice && totalComparePrice > totalPrice) {
        priceContainer.classList.add('price--on-sale');
        const regularEl = priceContainer.querySelector('.price__sale .price-item--regular');
        if (regularEl) {
          regularEl.textContent = '$' + totalComparePrice.toFixed(2) + ' USD';
        }
        const saleEl = priceContainer.querySelector('.price-item--sale.price-item--last');
        if (saleEl) {
          saleEl.textContent = '$' + totalPrice.toFixed(2) + ' USD';
        }
      } else {
        priceContainer.classList.remove('price--on-sale');
        const regularEl = priceContainer.querySelector('.price__regular .price-item--regular');
        if (regularEl) {
          regularEl.textContent = '$' + totalPrice.toFixed(2) + ' USD';
        }
      }
    }
    // Expose updatePrice on window for live access by external upsell elements
    window.RapidForceSelectorUpdatePrice = updatePrice;
  }

  function enableRow(rowId) {
    let id = rowId;
    if (rowId.endsWith('-row-gun')) return;
    if (rowId.endsWith('-row-hand')) return;
    if (rowId.endsWith('-row-axon')) id = prefix + '-axon-row';
    if (rowId.endsWith('-row-light')) id = prefix + '-light-row';
    if (rowId.endsWith('-row-color')) id = prefix + '-color-row';

    const row = document.getElementById(id);
    if (row) {
      row.style.display = '';
    }
  }

  boot();
};

// Auto-initialize if picker elements are found in DOM (resolves race conditions with deferred scripts)
if (typeof document !== 'undefined') {
  (function() {
    function initAuto() {
      console.log('[RapidForceSelector] Auto-initializing check...');
      const lvl2Picker = document.querySelector('[id="rf-lvl2-picker"]');
      if (lvl2Picker) {
        console.log('[RapidForceSelector] Found rf-lvl2-picker element. rfInitialized state:', lvl2Picker.dataset.rfInitialized);
        if (!lvl2Picker.dataset.rfInitialized) {
          lvl2Picker.dataset.rfInitialized = 'true';
          console.log('[RapidForceSelector] Instantiating Selector for rf-lvl2...');
          window.RapidForceSelector({
            prefix: 'rf-lvl2',
            sectionId: lvl2Picker.getAttribute('data-section') || '',
            dataUrl: lvl2Picker.getAttribute('data-url') || '',
            containerId: 'rf-lvl2-picker'
          });
        }
      } else {
        console.log('[RapidForceSelector] rf-lvl2-picker element NOT found in DOM.');
      }
    }
    document.addEventListener('DOMContentLoaded', initAuto);
    if (document.readyState === 'interactive' || document.readyState === 'complete') {
      initAuto();
    }
  })();
}
